import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import $ from "jquery";
gsap.registerPlugin(ScrollTrigger);

export const overlapSections = () => {
  const area = document.querySelector(".js-gallery-area");
  // const images = document.querySelectorAll(".js-gallery-img");
  const img01 = document.querySelector(".js-gallery-img-01");
  const img02 = document.querySelector(".js-gallery-img-02");
  const img03 = document.querySelector(".js-gallery-img-03");
  const img04 = document.querySelector(".js-gallery-img-04");

  const stick = document.querySelector(".js-gallery-stick");
  const count = document.querySelector(".js-gallery-count");

  ScrollTrigger.create({
    trigger: area,
    start: "top top",
    end: "bottom bottom",
    onUpdate: (self) => {
      console.log(self.progress);

      if (self.progress < 0.25) {
        count.textContent = "1";
      } else if (self.progress < 0.5) {
        count.textContent = "2";
      } else if (self.progress < 0.75) {
        count.textContent = "3";
      } else if (self.progress > 0.75) {
        count.textContent = "4";
      }
    },
    onEnter: () => {
      stick.classList.add("is-fixed");
    },
    onLeave: () => {
      stick.classList.remove("is-fixed");
      stick.classList.add("is-bottom");
    },
    onEnterBack: () => {
      stick.classList.add("is-fixed");
      stick.classList.remove("is-bottom");
    },
    onLeaveBack: () => {
      stick.classList.remove("is-fixed");
    },
  });

  const tl01 = gsap.timeline({
    scrollTrigger: {
      trigger: area,
      start: "top top",
      end: "+=100%",
      scrub: 1,
    },
  });
  tl01.to(img02, { y: "-100%" });

  const tl02 = gsap.timeline({
    scrollTrigger: {
      trigger: area,
      start: "top top",
      end: "+=200%",
      scrub: 1,
    },
  });
  tl02.to(img03, { y: "-200%" });

  const tl04 = gsap.timeline({
    scrollTrigger: {
      trigger: area,
      start: "top top",
      end: "+=300%",
      scrub: 1,
    },
  });
  tl04.to(img04, { y: "-300%" });

  // $(window).on("load scroll resize", function () {
  //   var length = $(".js-overlap-section").length;
  //   $(".js-overlap-section").each(function (i) {
  //     var setPos = $(this).outerHeight() - $(window).height() / 2;
  //     $(this).css("top", 0);
  //   });
  // });
};
